export const worldEn = {
  'world.seo.title': 'The World',
  'world.seo.description':
    'Explore the interactive maps of Grymwyrd — its kingdoms, ruins, and the scenes of legend, in 2D cartograph and a rotatable 3D globe.',
  'world.heading': 'The World',
  'world.intro':
    'Chart the eternal twilight. The atlas is built for nested vision — zoom from the whole world down to a single dungeon. Only the topmost tier is interactive for now; deeper tiers will open as the realms are mapped.',

  'world.viewMode.label': 'Map view mode',
  'world.viewMode.map2d': '2D Map',
  'world.viewMode.globe3d': '3D Globe',

  'world.gazetteer.navLabel': 'Locations and scenes',
  'world.gazetteer.heading': 'Gazetteer',
  'world.gazetteer.sampleNotice':
    "Showing sample places — the cartographer's true survey is not yet recorded.",
  'world.gazetteer.error': 'The atlas archive could not be reached.',

  'world.loading.atlas': 'Unrolling the atlas…',
  'world.loading.globe': 'Spinning the world…',

  'world.layersActive': '{active} of {total} layers active.',
  'world.globeHint':
    'Drag to rotate (auto-spin pauses while you explore, resuming after a minute idle); scroll to zoom in close. Hover a hex to reveal its campaign, click to enter.',
  'world.webglUnavailable':
    'The 3D globe needs WebGL, which is unavailable here — showing the 2D atlas instead.',

  'world.campaign.capitalRegion': 'Capital Region',
  'world.campaign.territory': 'Campaign Territory',
  'world.campaign.enter': 'Enter Campaign',
  'world.campaign.stay': 'Stay in Orbit',
  'world.campaign.enterCity': 'Enter {city} (Eternal City)',

  'world.layers.heading': 'Map Layers',
  'world.layers.gmBadge': 'GM',
  'world.layers.gmRequired': 'Requires a Game Master role.',

  'world.marker.sampleBadge': 'Sample data',
  'world.marker.viewInEncyclopedia': 'View in Encyclopedia',
  'world.marker.placeholderNote':
    'This is a placeholder site — once its lore is written it will link to the Encyclopedia.',

  'world.map2d.ariaLabel': 'Interactive overworld map',
  'world.map2d.noOverworld': 'Overworld cartograph not yet inscribed — showing the void',

  'world.globe.hint.enter': 'Enter ▸',
  'world.globe.hint.open': 'Open ▸',
  'world.globe.hint.claim': 'Claim ▸',
  'world.globe.uncharted': 'Uncharted Reaches',
  'world.globe.unchartedBlurb':
    'No campaign has claimed this hex of the eternal twilight. Stake the first banner.',
  'world.globe.capitalLabel': 'Grymwyrd',
} as const
